var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "cureentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "document_svg__st0",
    d: "M22.4 8.9h-.3V4.2c0-1.4-1.1-2.6-2.5-2.6H4.4C3 1.6 1.9 2.7 1.9 4.2v1.7h-.7C.5 5.9 0 6.4 0 7.1V20.7c0 .9.7 1.6 1.6 1.6h20.7c.9 0 1.6-.7 1.6-1.6V10.5c.1-.9-.6-1.6-1.5-1.6zM3.9 4.2c0-.3.2-.5.5-.5h15.2c.3 0 .5.2.5.5v4.7h-9.3L8.6 6.3c-.3-.3-.6-.4-.9-.4H3.9V4.2z"
  })));
};
export default SvgDocument;